// extracted by mini-css-extract-plugin
module.exports = {"container":"signIn_container__1nWY_","sign-in-block":"signIn_sign-in-block__3nw4b"};